import React from 'react';
import jss from 'jss';

import theme from '../../utils/theme';

const styles = (style) => ({
    root: {
        ...style,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: style.cursor || 'pointer',
        '@media print': {
            display: 'none',
        },
    },
});

export default function EditIconComponent({ color, size = 14, customStyles, ...props }) {
    const { classes } = jss.createStyleSheet(styles({ ...customStyles })).attach();

    return (
        <span className={classes.root} {...props}>
            <svg width={`${size}px`} height={`${size}px`} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.0909 1L17 3.90909L9.72728 11.1818L5.36364 12.6364L6.81819 8.27273L14.0909 1Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15.5455 12.6369V15.546C15.5455 15.9318 15.3922 16.3017 15.1194 16.5745C14.8466 16.8473 14.4767 17.0005 14.0909 17.0005H2.45455C2.06878 17.0005 1.69881 16.8473 1.42603 16.5745C1.15325 16.3017 1 15.9318 1 15.546V3.90962C1 3.52385 1.15325 3.15388 1.42603 2.8811C1.69881 2.60832 2.06878 2.45508 2.45455 2.45508H5.36364" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </span>
    );
}

EditIconComponent.defaultProps = {
    color: theme.colors.white,
    size: 10,
    type: 'button',
};
